// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3SP5q","label":"Radio_label__2xCu5","checkMark":"Radio_checkMark__3dbKg","disabled":"Radio_disabled__swGld"};